var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      style: _vm.css,
      attrs: {
        filterable: "",
        remote: "",
        clearable: "",
        disabled: _vm.id != undefined && _vm.id == "set_as_merchant_supervisor",
        "remote-method": _vm.loadTicketUserList,
        placeholder: "用手机号/账号/昵称搜索"
      },
      on: {
        clear: _vm.onClear,
        focus: _vm.onFocus,
        change: _vm.onChange,
        "visible-change": _vm.onVisibleChange
      },
      model: {
        value: _vm.ticketUser.id,
        callback: function($$v) {
          _vm.$set(_vm.ticketUser, "id", $$v)
        },
        expression: "ticketUser.id"
      }
    },
    _vm._l(_vm.ticketUserList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.label, value: item.id }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e55e40fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e55e40fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/DealUserSearch.vue
// module id = 750
// module chunks = 75